import { render, staticRenderFns } from "./QARequest.vue?vue&type=template&id=a643f0da&scoped=true&"
import script from "./QARequest.vue?vue&type=script&lang=js&"
export * from "./QARequest.vue?vue&type=script&lang=js&"
import style0 from "./QARequest.vue?vue&type=style&index=0&id=a643f0da&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a643f0da",
  null
  
)

export default component.exports